import { message, Modal } from 'antd';
import moment from 'moment';

import axiosWithAuth from '@/lib/axios';
import type { UploadFix } from '@/types/database/fix';

import type { FixFormValues, FixTableData } from '../types';

export const getInitialValues = (data: FixTableData | null) => {
  let initialValues: FixFormValues = {
    title: '',
    householdNumber: [],
    category: { name: '家中設備' },
    content: '',
    bookingTime: moment(),
    image: [],
  };

  if (!data) {
    return initialValues;
  }

  const { householdNumber, category, title, content, bookingTime, image } =
    data;
  initialValues = {
    householdNumber: householdNumber.split('-'),
    category,
    title,
    content,
    bookingTime: moment(bookingTime),
    image: [],
  };
  if (image) {
    initialValues.image = [
      {
        uid: '1',
        name: image.name,
        status: 'done',
        url: image.path,
      },
    ];
  }

  return initialValues;
};

export const getNewFixUploadValues = async (values: FixFormValues) => {
  const newValues: UploadFix = {
    ...values,
    householdNumber: values.householdNumber.join('-'),
    bookingTime: values.bookingTime.toISOString(),
    image: null,
  };
  // 新上傳的圖片
  if (values?.image?.[0]?.originFileObj) {
    const newFile = values.image[0].originFileObj;
    const formData = new FormData();
    formData.append('files', newFile);
    const { data } = await axiosWithAuth.post('/newUploads?type=fix', formData);
    newValues.image = {
      name: data[0].orignalName,
      path: data[0].showPath,
    };
    // 已上傳的圖片
  } else if (values?.image?.[0]?.url) {
    newValues.image = {
      name: values.image[0].name,
      path: values.image[0].url,
    };
  }
  return newValues;
};

export const handleEdit = async ({
  values,
  type,
  fixId,
}: {
  values: FixFormValues;
  type: 'create' | 'edit';
  fixId: string | null;
}) => {
  try {
    const newValues = await getNewFixUploadValues(values);

    let uploadWork: Promise<any> | null = null;
    let messageText = '';
    if (type === 'create') {
      uploadWork = axiosWithAuth.post('/ezcon/api/fixes', newValues);
      messageText = '新增成功';
    } else if (type === 'edit' && fixId) {
      uploadWork = axiosWithAuth.patch(`/ezcon/api/fixes/${fixId}`, newValues);
      messageText = '修改成功';
    }
    if (uploadWork) {
      await uploadWork;
      message.success(messageText);
    }
  } catch (error) {
    console.error(error);
    message.error('發生錯誤，請稍後再試');
  }
};

export const handleDelete = (fixId: string, onClose: () => void) => {
  Modal.confirm({
    title: '確定刪除？',
    content: '刪除後將無法復原',
    okText: '刪除',
    cancelText: '取消',
    centered: true,
    onOk: async () => {
      try {
        await axiosWithAuth.delete(`/ezcon/api/fixes/${fixId}`);
        message.success('刪除成功');
        onClose();
      } catch (error) {
        console.error(error);
        message.error('發生錯誤，請稍後再試');
      }
    },
  });
};
